import { isRejectedWithValue, Middleware } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import * as Sentry from "@sentry/react";

export const rtkQuerySentryMiddleware: Middleware =
  () => (next) => (action) => {
    if (isRejectedWithValue(action)) {
      const rtkError = action.payload as FetchBaseQueryError;

      const message =
        typeof rtkError === "object" &&
        rtkError !== null &&
        "data" in rtkError &&
        rtkError.data
          ? JSON.stringify(rtkError.data)
          : "API Error";

      const sentryError = new Error(message);

      Sentry.withScope((scope) => {
        scope.setTag("redux-action", action.type);

        if (typeof rtkError === "object" && rtkError !== null) {
          scope.setExtra("status", rtkError.status);
          scope.setContext("rtk-error", rtkError);
        }

        Sentry.captureException(sentryError);
      });
    }

    return next(action);
  };
